import SbpsAmazonPayConfirmForm from '../../components/molecules/sbps/SbpsAmazonPayConfirmForm.vue'
export default {
  components: { SbpsAmazonPayConfirmForm }
}
